import type React from 'react'

import ReactDOM from 'react-dom'
import scrollIntoView from 'scroll-into-view'

import logger from 'utils/logger'

type WithGetBoundingClientRect =
  | {
      getBoundingClientRect?: () => DOMRect
    }
  | null
  | undefined

type RefsMap = Record<string, React.Component<any, any> | Element | Text | null | undefined>

export function getBoundingClientRect(ref?: WithGetBoundingClientRect): Partial<DOMRect> {
  let size: Partial<DOMRect> = {}
  if (ref && ref.getBoundingClientRect) {
    size = ref.getBoundingClientRect()
  }

  return size
}

export function getFirstMatchingNode(
  keys: string[] = [],
  refs: RefsMap = {},
): Element | Text | undefined {
  let matchingNode: Element | Text | null | undefined

  const matchFound = keys.some((key) => {
    if (refs[key]) {
      try {
        // eslint-disable-next-line react/no-find-dom-node
        matchingNode = ReactDOM.findDOMNode(refs[key] as any)
      } catch (err) {
        logger.warning(`getFirstMatchingNode: ${err}`)
      }
    }

    return Boolean(matchingNode)
  })

  return matchFound ? (matchingNode as Element | Text) : undefined
}

export const DOMHelper = {
  getFirstMatchingNode,
}

export function scrollToFirstMatchingNode(keys: string[] = [], refs: RefsMap = {}): void {
  const firstFoundErrorEl = DOMHelper.getFirstMatchingNode(keys, refs)

  if (firstFoundErrorEl) {
    scrollIntoView(firstFoundErrorEl as any)
  } else {
    logger.warning('scrollToFirstMatchingNode: no matches found in refs')
  }
}

export function getElementOffsetTop(
  doc: Document | null | undefined,
  selector: string,
): number | undefined {
  const elementOffsetTop =
    doc && doc.querySelector(selector) && (doc.querySelector(selector) as HTMLElement)?.offsetTop

  return elementOffsetTop as number | undefined
}

export const isNodeInRoot = (
  node: Node | null | undefined,
  root: Node | null | undefined,
): boolean => {
  let parent = node as Node | null | undefined
  while (parent) {
    if (parent === root) {
      return true
    }
    parent = (parent as Node).parentNode as Node | null | undefined
  }

  return false
}
